import React, { Component } from 'react';
import { isEmpty, size } from "lodash";
import { Box, Typography, Dialog, DialogContent, IconButton, Table, TableBody, TableCell, TableRow, AppBar, Toolbar, TableHead, TableFooter, TablePagination  } from '@mui/material';
import SwipeableTabs from '../../../container/MUI/SwipeableTabs';
import { Close } from '@mui/icons-material';
import Currency from '../../common/Currency';
import Pagination from '../../../container/MUI/Pagination';
import StackedStats from "../../Stats/StackedStats"
import SpendingDetails from '../../Spendings/SpendingDetails';
import SupplierBalance from './SupplierBalance';
import TitleWithEndAction from '../../common/TitleWithEndAction';

class SupplierSingle extends Component {
    state = { 
        page: 0,
        rowsPerPage: 10,
        spendings: [],
        advances: [],
        total: 0,
        totalDu: 0,
        totalHT: 0,
        totalTVA: 0,
        totalTaxesCredit: 0,
        totalTaxesDebit: 0,
        openDetails: false, 
        selectedSpending: {}
    }
    componentDidMount = async () => {
        // if(isEmpty(this.props.SPENDINGS) ){
        //     await this.props.fetchSpendings()
        // }  
        // if(isEmpty(this.props.CATEGORIES.PARENT)){
        //     this.props.fetchParentCategories()
        // }
        // if(isEmpty(this.props.CATEGORIES.CHILD)){
        //     this.props.fetchChildCategories()
        // }
        this.filterSpendings()
    }
    handleChangePage = (event, page) => {
        this.setState({ page });
    };

    handleChangeRowsPerPage = event => {
        this.setState({ page: 0, rowsPerPage: parseInt(event.target.value) });
    };


    filterSpendings = () => {
        const { SPENDINGS, ADVANCES, supplier } = this.props;
        let filteredList = !isEmpty(SPENDINGS) ? Object.values(SPENDINGS).filter(item => item.spending_supplier === supplier.supplier_id) : []
        let filteredAdvances = !isEmpty(ADVANCES) ? Object.values(ADVANCES).filter(item => item.advance_supplier_id === supplier.supplier_id) : []
        
        console.log('====================================');
        console.log({filteredList});
        console.log('====================================');
        let total = 0
        let totalDu = 0
        let totalHT = 0
        let totalTVA = 0
        let totalTaxesCredit = 0
        let totalTaxesDebit = 0
        filteredList.forEach(item => {
            total += Number(item.spending_amountTTC) || 0;
            totalDu += Number(item.spending_rest_to_pay) || 0
            // Totaux sur toutes les dépenses du fournisseur (pas seulement la page affichée)
            totalHT += Number(item.spending_amount) || 0
            totalTVA += Number(item.spending_TVA) || 0
            totalTaxesCredit += Number(item.spending_taxes) || 0
            totalTaxesDebit += Number(item.spending_taxes_debit) || 0
        })

        this.setState({
            spendings: filteredList,
            advances: filteredAdvances,
            total,
            totalDu,
            totalHT,
            totalTVA,
            totalTaxesCredit,
            totalTaxesDebit,
        })
    }
    displaySpendings = () => {
        const { rowsPerPage, page, spendings } = this.state;
        const { CATEGORIES } = this.props;
        
        return spendings.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map( item => {
            let category = CATEGORIES.CHILD[item.spending_category]
            // let user = isEmpty(USERS) ? {} : USERS[item.spending_user]
            // let labels = LABELS && item.spending_labels && this.displayLabels(item.spending_labels)
            // let supplier = isEmpty(SUPPLIERS) ? {} : SUPPLIERS[item.spending_supplier]

            return (
                <TableRow 
                    hover
                    key={item.spending_id}
                    onClick={() => this.setState({openDetails: true, selectedSpending: item }) }
                >
                    <TableCell >{new Date(item.spending_date).toLocaleDateString('fr-FR')}</TableCell>
                    <TableCell >{ category && category.category_name}</TableCell>                     
                    <TableCell>{item.spending_desc}</TableCell>   
                    <TableCell><Currency value={Number(item.spending_amount) || 0} /></TableCell>
                    <TableCell><Currency value={Number(item.spending_TVA) || 0} /></TableCell>
                    <TableCell><Currency value={Number(item.spending_taxes) || 0} /></TableCell>
                    <TableCell><Currency value={Number(item.spending_taxes_debit) || 0} /></TableCell>
                    <TableCell><Currency value={item.spending_amountTTC} /></TableCell>                     
                    <TableCell>
                        {!item.spending_fully_paid &&
                            <Currency value={item.spending_rest_to_pay} />
                        }
                    </TableCell>                     
                </TableRow>
            )
        })
    }
    render() {
        const { supplier, CATEGORIES, BANKS, PAYMENTS, LABELS } = this.props;
        const { spendings, rowsPerPage, page, total, totalDu, totalHT, totalTVA, totalTaxesCredit, totalTaxesDebit, openDetails, selectedSpending} = this.state;
        return (
            <Dialog
                // disableBackdropClick
                open={true}
                // onClose={this.props.handleClose}
                onClose={(_, reason) => {reason !== "backdropClick" && this.props.handleClose()} }
                aria-labelledby="form-dialog-title"
                maxWidth="lg"
                fullScreen
                scroll="paper"
            >
                {openDetails && selectedSpending && 
                    <SpendingDetails 
                        supplier={supplier} 
                        LABELS={LABELS}
                        BANKS={BANKS}
                        PAYMENTS={PAYMENTS}
                        category={CATEGORIES.CHILD && CATEGORIES.CHILD[selectedSpending.spending_category]} 
                        spending={selectedSpending} 
                        view={"ADMIN"}
                        handleClose={()=> this.setState({openDetails: false, selectedSpending: {}})}
                        fetchSpendingPayments={this.props.fetchSpendingPayments}
                    />
                }
                <AppBar style={{position: 'relative'}} color="secondary">
                    <Toolbar>
                        <IconButton color="inherit" onClick={this.props.handleClose} aria-label="Close">
                            <Close />
                        </IconButton>
                        <Typography variant="h6" color="inherit">
                        {supplier.supplier_name}
                        </Typography>
                    </Toolbar>
                </AppBar>
                    
                <DialogContent>
                    <Box>
                        <SwipeableTabs
                            tab={this.props.tab}
                            labels={["Statistiques", "Dépenses", "Balance"]}
                            
                        >
                            <Box p={3}>
                                {/* Total: <Currency value={total} /> <br/> */}
                                Reste à Payer: <Currency value={totalDu} />
                                <StackedStats 
                                    CATEGORIES={this.props.CATEGORIES.CHILD}
                                    SPENDINGS={this.state.spendings}
                                />
                            </Box>
                            <Box p={3}>
                                <TitleWithEndAction
                                    title= " "
                                    action={() => this.props.openFormCustom(this.props.supplier.supplier_id)}
                                />
                                <Table>
                                    <TableHead>
                                        <TableRow>
                                            <TableCell>Créé le</TableCell>
                                            <TableCell>Catégorie</TableCell>
                                            <TableCell>Description</TableCell>
                                            <TableCell>Montant HT</TableCell>
                                            <TableCell>TVA</TableCell>
                                            <TableCell>Autres Taxes (Crédit)</TableCell>
                                            <TableCell>Autres Taxes (Débit)</TableCell>
                                            <TableCell>Montant TTC</TableCell>
                                            <TableCell>Reste à Payer</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {!isEmpty(spendings) && !isEmpty(CATEGORIES.CHILD) && this.displaySpendings()}
                                    </TableBody>
                                    {!isEmpty(spendings) &&
                                        <TableFooter>
                                            <TableRow>
                                                <TableCell colSpan={3}><strong>Total ({size(spendings)} dépenses)</strong></TableCell>
                                                <TableCell><strong><Currency value={totalHT} /></strong></TableCell>
                                                <TableCell><strong><Currency value={totalTVA} /></strong></TableCell>
                                                <TableCell><strong><Currency value={totalTaxesCredit} /></strong></TableCell>
                                                <TableCell><strong><Currency value={totalTaxesDebit} /></strong></TableCell>
                                                <TableCell><strong><Currency value={total} /></strong></TableCell>
                                                <TableCell><strong><Currency value={totalDu} /></strong></TableCell>
                                            </TableRow>
                                            {size(spendings) > 10 &&
                                            <TableRow>
                                                <TablePagination
                                                    rowsPerPageOptions={[10, 30]}
                                                    labelRowsPerPage="Lignes par Page"
                                                    colSpan={9}
                                                    count={size(spendings)}
                                                    rowsPerPage={rowsPerPage}
                                                    page={page}
                                                    SelectProps={{
                                                        native: true,
                                                    }}
                                                    onPageChange={this.handleChangePage}
                                                    onRowsPerPageChange={this.handleChangeRowsPerPage}
                                                    ActionsComponent={Pagination}
                                                />
                                            </TableRow>
                                            }
                                        </TableFooter>
                                    }
                                </Table>
                            </Box>
                            <Box p={3}>
                                <SupplierBalance 
                                    SPENDINGS={this.props.SPENDINGS}
                                    ADVANCES={this.props.ADVANCES}
                                    PAYMENT_DETAILS={this.props.PAYMENT_DETAILS}
                                    supplier={supplier}
                                />
                            </Box>
                        </SwipeableTabs>
                    </Box>


                </DialogContent>
            </Dialog>
        );
    }
}

export default SupplierSingle;